import modalConfirmation from '../../shared/components/modal-response/modal-response.view.html';
import modalQuantityCart from '../modal-quantity-cart/modal-quantity-cart.view.html';
import modalConfirmationCart from '../modal-confirmation/modal-confirmation.view.html';

let inject = [
    '$scope',
    'CatalogService',
    'CategoryService',
    '$state',
    '$rootScope',
    'SharedService',
    '$stateParams',
    '$uibModal',
    'Pagination',
    'ngAuthSettings',
    '$timeout',
    'CartService',
    'ByFavoritesService',
    '$mdToast',
    'SessionService'
];

class ProductsListController {
    constructor($scope, CatalogService, CategoryService, $state, $rootScope, SharedService, $stateParams, $uibModal, Pagination, ngAuthSettings, $timeout, CartService, ByFavoritesService, $mdToast, SessionService) {
        this.$state = $state;
        this.$scope = $scope;
        this.ngAuthSettings = ngAuthSettings;
        this.Pagination = Pagination;
        this.CatalogService = CatalogService;
        this.$stateParams = $stateParams;
        this.CartService = CartService;
        this.$rootScope = $rootScope;
        this.$uibModal = $uibModal;
        this.$mdToast = $mdToast;
        this.SessionService = SessionService;
        this.CategoryService = CategoryService;
        this.SharedService = SharedService;
        this.$timeout = $timeout;
        this.loanding = false;
        this.itemQuantityToAdd = 1;
        this.pagerCategories = [];
        this.itemsPerPage = 12;
        this.loadingCategories = true;
        this.ByFavoritesService = ByFavoritesService;
        this.productsToCompare = {
            customLength: 0,
            items: {}
        };
        this.dataCart = {};
        this.dataProducs = {};
        this.view = 50;
        this.productItems = {};
        this.productAdded = {};

    }

    $onInit() {
        this.$timeout(() => {
            let maxHeight = 0;
            let itemProduct = $(".item-product");
            itemProduct.each(function () {
                if ($(this).height() > maxHeight) {
                    maxHeight = $(this).height();
                }
            });
            itemProduct.height(maxHeight);
            $('.add-tooltip').tooltip();
            $('a[data-toggle="tooltip"]').tooltip();
        }, 1000)

    }

    setItemToAddToCart(product) {
        this.dataCart = {};
        this.dataProducs = {};

        product.id = parseInt(product.id);
        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalQuantityCart,
            controller: 'ModalQuantityCartController',
            controllerAs: 'mdCtrl',
            size: 'sm',
            resolve: {
                product: () => product
            }
        });

        modalInstance.result.then(result => {

            if (result.product.id && result.quantity) {
                let userId = '', cart = null;
                try {
                    userId = this.shCtrl.globals.currentUser.userId;
                } catch (e) {
                }
                try {
                    cart = this.shCtrl.cart;
                } catch (e) {
                }

                let validation  = this.SessionService.validateFactorItems(result.quantity,product);

                if(validation.error){

                    let options = {
                        title: '',
                        isHtml: true,
                        content: validation.message,
                        size: '',
                        showBottonCancel: false,
                        textActionCancel: '',
                        textAction: 'Aceptar'
                    };
                    this.messageResponse(options);
                    return;
                }

                this.CartService.addItemToCart(result.product, result.quantity, null, null, userId, cart).then(response => {
                    if (!response.error) {
                        this.dataCart = {};
                        this.dataProducs = {};
                        let discountItem = 0;

                        if(response.discountItem > 0){
                          discountItem = response.discountItem;
                        }
                        this.modalConfirmation(product, result.quantity,discountItem);


                    } else {
                        if (response.agotado) {
                            product.cantidad = response.itemStock;
                            this.CartService.updateItemsNotAvailable(product, result.quantity, userId);
                        }
                        if (__env.adaptative) {
                            this.messageMaterial(response.message);
                        }
                        else {


                            let options = {
                                title: '',
                                isHtml: true,
                                content: response.message,
                                size: '',
                                showBottonCancel: false,
                                textActionCancel: '',
                                textAction: 'Aceptar'
                            };
                            this.messageResponse(options);
                        }


                    }
                }).catch(reason => {
                    if (__env.adaptative) {
                        this.messageMaterial(reason.toString());
                    } else {
                        let options = {
                            title: '',
                            isHtml: true,
                            content: reason.toString(),
                            size: '',
                            showBottonCancel: false,
                            textActionCancel: '',
                            textAction: 'Aceptar'
                        };
                        this.messageResponse(options);
                    }

                });
            }
        }).catch(error => {

        });
    }

    compareProductsSelected() {
        let keys = Object.keys(this.productsToCompare.items);
        this.$state.go('home.compare', {categoryId: '', products: keys});
    }


    updateProductToCompare(value) {
        let keys = Object.keys(this.productsToCompare.items);
        let indexOf = keys.indexOf(value);
        if (indexOf !== -1) {

            keys.splice(indexOf, 1);
            let newObjectToCompare = {};
            keys.forEach(function (val) {
                newObjectToCompare[val] = true;
            });
            this.productsToCompare.items = angular.copy(newObjectToCompare);
            this.productsToCompare.customLength = keys.length;
        }
        else {
            this.productsToCompare.items[value] = true;
            this.productsToCompare.customLength++;
        }
    }

    updateFavoriteProducts(product) {
        product.isSettingAsFavorite = true;
        let userId = '';
        try {
            userId = this.shCtrl.globals.currentUser.userId;
        }
        catch (e) {
        }
        if (userId) {
            let data = {
                'productId': product.id,
                'userId': userId,
                'setFavorite': !product.isFavorite
            };
            this.CatalogService.updateFavoriteProducts(data).then(response => {
                product.isFavorite = !product.isFavorite;
                product.isSettingAsFavorite = false;

                if (!response.error) {
                    this.ByFavoritesService.getResumeProductsFavorites(this.shCtrl.globals.currentUser.userId).then(favoritesResponse => {
                        this.shCtrl.globals.currentUser.favoriteItems = favoritesResponse;
                        this.SessionService.put('globals', this.shCtrl.globals);

                    });
                }

            }).catch(error => {
                product.isSettingAsFavorite = false;
                let options = {
                    title: '',
                    isHtml: false,
                    content: 'Ha ocurrido un error al actualizar el producto',
                    size: '',
                    showBottonCancel: false,
                    textActionCancel: '',
                    textAction: 'Aceptar'
                };
                this.messageResponse(options);
            });
        }
    }


    messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalConfirmation,
            controller: 'ModalResponseController',
            controllerAs: 'mdCtrl',
            size: options.size,
            resolve: {
                modalOptions: () => options
            }
        });
        modalInstance.result.then(() => {
            if (callAcept) {
                callback();
            }
        }).catch(reason => {
            if (callCancel) {
                callbackCancel();
            }
        });
    }

    messageMaterial(text) {
        var mdToast = this.$mdToast;
        this.$mdToast.show({
            hideDelay: 4000,
            controller: function () {
                this.closeToast = function () {
                    mdToast.hide();
                }

            },
            controllerAs: 'toast',
            template: '<md-toast>\n' +
            '  <span class="md-toast-text">' + text + '</span>\n' +
            '  <md-button ng-click="toast.closeToast()">\n' +
            '    Cerrar\n' +
            '  </md-button>\n' +
            '</md-toast>'
        });
    }

    modalConfirmation(products, quantity, discount = null) {

      this.productAdded = products;
      this.productAdded.activateVolumenPrice = products.activateVolumenPrice;
      this.productAdded.image = products.imagesDetail[0].path + products.imagesDetail[0].image;
      this.productAdded.price = products.itemPrice;
      this.productAdded.discount = discount * quantity;
      //this.productAdded.ivaValue = products.taxValue;
      this.productAdded.quantity = quantity;

      let taxValues  = ((products.itemPrice -  discount)  * products.taxPercentage / 100);
      this.productAdded.ivaValue = taxValues * quantity;
      if (products.preciosxvolumen == null) {
        this.productAdded.total = (products.itemPrice - discount + taxValues) * quantity;
      }

        else if (!products.preciosxvolumen[2] && !products.preciosxvolumen[1]) {
          if (products.quantity > products.preciosxvolumen[0].hasta){
            this.productAdded.total = (products.preciosxvolumen[0].itemPrice - products.preciosxvolumen[0].itemDiscount + products.preciosxvolumen[0].taxValue) * quantity;
          }
          else {
            this.productAdded.totalpxv1 = (products.preciosxvolumen[0].itemPrice - products.preciosxvolumen[0].itemDiscount + products.preciosxvolumen[0].taxValue) * quantity;
          }
        }

        else if (!products.preciosxvolumen[2]){
          if (products.quantity > products.preciosxvolumen[1].hasta){
            this.productAdded.total = (products.preciosxvolumen[1].itemPrice - products.preciosxvolumen[1].itemDiscount + products.preciosxvolumen[1].taxValue) * quantity;
          }
          else {
            this.productAdded.totalpxv1 = (products.preciosxvolumen[0].itemPrice - products.preciosxvolumen[0].itemDiscount + products.preciosxvolumen[0].taxValue) * quantity;
            this.productAdded.totalpxv2 = (products.preciosxvolumen[1].itemPrice - products.preciosxvolumen[1].itemDiscount + products.preciosxvolumen[1].taxValue) * quantity;
          }
        }

        else {
          this.productAdded.totalpxv1 = (products.preciosxvolumen[0].itemPrice - products.preciosxvolumen[0].itemDiscount + products.preciosxvolumen[0].taxValue) * quantity;
          this.productAdded.totalpxv2 = (products.preciosxvolumen[1].itemPrice - products.preciosxvolumen[1].itemDiscount + products.preciosxvolumen[1].taxValue) * quantity;
          this.productAdded.totalpxv3 = (products.preciosxvolumen[2].itemPrice - products.preciosxvolumen[2].itemDiscount + products.preciosxvolumen[2].taxValue) * quantity;
        }


      if (__env.adaptative) {
            this.messageMaterial(products.name + ' Ha sido agregado correctamente')
        } else {
            $('#productList').modal('toggle');
        }

        this.$scope.$emit('onUpdateCart', 'modalResponseItems');
    }

    increaseItemQuantityToAdd() {
        if (!this.itemQuantityToAdd)
            this.itemQuantityToAdd = 1;
        else
            this.itemQuantityToAdd++;
    };

    decreaseItemQuantityToAdd() {
        if (!this.itemQuantityToAdd)
            this.itemQuantityToAdd = 1;
        else if (this.itemQuantityToAdd > 1) {
            this.itemQuantityToAdd--;
        }
    };
}

ProductsListController.$inject = inject;

export default ProductsListController;




/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/catalog/products-list/products-list.controller.js
 **/